import BaseDialog from './../../../zzl-vue-component/BaseDialog'
import MediaList from './../../api/MediaList'
import { normalize } from './../../../zzl-lib/Zenkaku'

const MAX_RESULTS = 5
const SEARCH_DELAY = 150

export default {
	name: 'FileSelectView',
	props: {
		uid: {
			type: String,
		},
		name: {
			type: String,
		},
	},
	data() {
		return {
			query: '',
			queryTimer: null,
			items: [],
			matchedItems: [],
			fileDragover: false,
		}
	},
	components: {
		BaseDialog,
	},
	// 外側の div で誤ってファイルをドロップしてもファイルが開かないようにする
	template: `
		<div
			@dragover="$event.preventDefault()"
			@drop="$event.preventDefault()"
		>
			<BaseDialog class="file-select"
				title=""
			>
				<section class="bs-ed-dialog-sec">
					<h3 class="bs-ed-dialog-sec-hd">既存のファイルを追加</h3>
					<input type="text" class="form-control" v-model="query" placeholder="名前から検索"
						ref="firstInput"
					/>
					<span v-if="emptyQuery" class="label label-default">最近追加したファイル</span>
					<div class="list-group file-select-list-group">
						<div class="list-group-item file-select-search-result-item disabled"
							v-if="matchedItems.length === 0"
						>
							ファイルがありません
						</div>
						<div class="list-group-item file-select-search-result-item"
							v-for="item in matchedItems" :key="item.id"
							@click="selectItem(item)"
							tabindex="0"
						>
							<div>
								{{item.name}}
								<span class="small text-muted">{{item.filename}}</span>
							</div>
							<div class="small text-muted" v-if="item.desc">{{item.desc}}</div>
						</div>
					</div>
				</section>

				<section class="bs-ed-dialog-sec">
					<h3 class="bs-ed-dialog-sec-hd">新規追加</h3>
					<div class="file-select-drop-target"
						:class="{ 'file-select-drop-target-active': fileDragover }"
						@dragover="fileDragover = true; $event.preventDefault()"
						@dragleave="fileDragover = false"
						@drop="onFileDrop"
					>
						<label for="file-select-file-input" class="btn btn-default" tabindex="0">
							ファイルを選択...
						</label>
						<span class="dtl">またはファイルをここにドラッグ</span>
						<input type="file" id="file-select-file-input"
							@change="onFileInput"
						/>
					</div>
				</section>

				<template v-slot:buttons>
					<button type="button" class="bs-ed-btn bs-ed-btn-default"
						@click="$emit('cancel')"
					>
						キャンセル
					</button>
				</template>
			</BaseDialog>
		</div>
	`,
	mounted() {
		this.$refs.firstInput.focus()

		MediaList.get().then(items => {
			this.items = items.map(item => {
				item._searchText = [item.name, item.filename].map(s => s.toLowerCase()).join(' ')
				return item
			})
			this.search()
		})
	},
	beforeDestroy() {
		clearTimeout(this.queryTimer)
	},
	computed: {
		emptyQuery() {
			return this.query.trim() === ''
		}
	},
	methods: {
		search() {
			if (this.emptyQuery) {
				this.matchedItems = this.items.slice(0, MAX_RESULTS)
			} else {
				const nQueries = normalize(this.query.trim().toLowerCase()).split(/\s/)
				this.matchedItems = this.items
					.map(item => {
						const score = nQueries.map(q => {
							const i = item._searchText.indexOf(q)
							return (i === 0) ? 2 : ((i > 0) ? 1 : 0) + (item.type === q ? 1 : 0)
						}).reduce((sum, cur) => sum * cur, 1)
						return { item, score }
					})
					.filter(item => item.score > 0)
					.sort((x, y) => y.score - x.score)
					.map(itemScore => itemScore.item)
					.slice(0, MAX_RESULTS)
			}
		},
		selectItem(item) {
			// JSON を経由することでプレーンなオブジェクトに変換する
			this.$emit('input', JSON.parse(JSON.stringify(item)))
		},
		onFileInput(event) {
			if (!event || !event.target || !event.target.files || !event.target.files[0]) return
			this.$emit('fileinput', event.target.files[0])
		},
		onFileDrop(event) {
			event.preventDefault()
			this.fileDragover = false
			if (!event || !event.dataTransfer || !event.dataTransfer.files || !event.dataTransfer.files[0]) return
			this.$emit('fileinput', event.dataTransfer.files[0])
		},
	},
	watch: {
		query() {
			clearTimeout(this.queryTimer)
			this.queryTimer = setTimeout(() => this.search(), SEARCH_DELAY)
		}
	}
}
